
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { LogService } from "@/services";

@Component
export default class HeadMetadata extends Vue {
  @Prop()
  private title!: string;

  created(): void {
    this.updateAttributes();
  }

  @Watch("title")
  private titleChanged(): void {
    this.updateAttributes();
  }

  updateAttributes(): void {
    if (this.title) {
      document.title = this.title;
      this.setHeadElementAttribute(`meta[itemprop="name"]`, this.title);
      this.setHeadElementAttribute(`meta[property="og:title"]`, this.title);
      this.setHeadElementAttribute(`meta[name="twitter:title"]`, this.title);
    }
  }

  setHeadElementAttribute(selector: string, attribute: string): void {
    const element: Element | null = document.head.querySelector(selector);
    if (!element) {
      LogService.warn(`HeadMetadata : head element '${selector}' is missing.`);
    } else {
      if (!attribute) {
        element.removeAttribute("content");
      } else {
        element.setAttribute("content", attribute);
      }
    }
  }
}
